import { render, staticRenderFns } from "./CookiesBannerModal.vue?vue&type=template&id=5a0fc4bb"
import script from "./CookiesBannerModal.vue?vue&type=script&lang=js"
export * from "./CookiesBannerModal.vue?vue&type=script&lang=js"
import style0 from "./CookiesBannerModal.vue?vue&type=style&index=0&id=5a0fc4bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports